class CareTips extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this._activeItem = ''
    this.hasOpenItem = false

    this.listeners.add(this, 'click', this.handleTrigger)

    this.handleMouseEnter = this.handleMouseEnter.bind(this)
    this.handleMouseLeave = this.handleMouseLeave.bind(this)

    this.els.trigger.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'mouseenter', this.handleMouseEnter)
      this.listeners.add(triggerEl, 'mouseleave', this.handleMouseLeave)
    })
  }

  handleMouseEnter (e) {
    if (this.hasOpenItem) return

    this.activeItem = e.currentTarget.dataset.index
  }

  handleMouseLeave () {
    if (this.hasOpenItem) return

    this.activeItem = '0'
  }

  handleTrigger (event) {
    const clickedTriggerEl = event.target.closest(this.els?.trigger?.selector)
    if (!clickedTriggerEl) return

    const currentState =
      clickedTriggerEl.getAttribute('aria-expanded') === 'true'

    this.hasOpenItem = !currentState
    this.activeItem = clickedTriggerEl.dataset.index

    this.els.trigger.elements.forEach((triggerEl) => {
      if (triggerEl === clickedTriggerEl) {
        triggerEl.setAttribute('aria-expanded', !currentState)
      } else if (this.dataset.type === 'oneopen') {
        triggerEl.setAttribute('aria-expanded', false)
      }
    })

    this.els.content.elements.forEach((contentEl) => {
      if (contentEl.id === clickedTriggerEl.getAttribute('aria-controls')) {
        contentEl.setAttribute('aria-hidden', currentState)

        if (currentState === false) {
          contentEl.scrollIntoView({ block: 'start', behavior: 'smooth' })
        }
      } else if (this.dataset.type === 'oneopen') {
        contentEl.setAttribute('aria-hidden', true)
      }
    })
  }

  get activeItem () {
    return this._activeItem
  }

  set activeItem (key) {
    this._activeItem = key

    this.els.media.elements.forEach((mediaEl) => {
      mediaEl.classList.toggle(
        'sec-CareTips_Media-active',
        mediaEl.dataset.index === this._activeItem,
      )
    })
  }
}

if (!customElements.get('care-tips')) {
  customElements.define('care-tips', CareTips)
}
